<template>
	<div class="auth login">
		<h1>{{ $t('base.auth.login') }}</h1>
		<form @submit.prevent="validateAndSubmit" class="form-auth">
			<error-box v-if="error" :error="error"/>
			<input-text v-model="model.email" name="login_email" :placeholder="$t('labels.auth.email')" rules="required|email"/>
			<input-password v-model="model.password" autocomplete="current-password" name="login_password" :placeholder="$t('labels.auth.password')" rules="required"/>
			<div class="form-group">
				<button-submit :loading="loading">{{ $t('buttons.auth.login') }}</button-submit>
			</div>
			<router-link class="sk-login__link-extra" :to="{ name: 'AuthPasswordRequest' }">{{ $t('base.auth.forgot_password') }}</router-link>
			<router-link class="sk-login__link-extra" :to="{ name: 'AuthRegister'}">{{ $t('base.auth.no_account') }}</router-link>
		</form>
	</div>
</template>

<script>
import ServiceWorker from '@/sw'
export default {
	data () {
		return {
			loading: false,
			model: {
				email: '',
				password: ''
			},
			error: null
		}
	},
	methods: {
		validateAndSubmit () {
			this.$validator.validateAll().then(result => {
				if (result) this.submit()
			})
		},
		submit () {
			this.loading = true
			this.$store.dispatch('clearAll')
			this.$api.auth.login(this, this.model).then(response => {
				this.$log.info('user login', 'auth.login OK', response)()

				const token = response.data.token
				const user = this.parseJwt(token)

				window.localStorage.setItem('token', token)
				window.localStorage.setItem('user', JSON.stringify(user))

				this.$store.dispatch('setAuthenticated', { token, user })
				this.$store.dispatch('getUser', { context: this })

				// Register serviceworker
				ServiceWorker.register(() => {
					ServiceWorker.setupClient(this)
				})

				this.$root.$emit('show-introduction', user.uid)

				if (this.$route.query.redirect !== undefined) {
					this.$router.push(this.$route.query.redirect)
				} else {
					const account = window.localStorage.getItem('account')
					const selectedAccount = account == user.uid ? window.localStorage.getItem('selectedAccount') || user.uid : user.uid
					this.$router.push({ name: 'Dashboard', params: { user_uid: selectedAccount } })
				}

				// enable notifications in where
				this.$store.dispatch('activePushToken', { context: this, token: ServiceWorker.pushToken })

			}).catch(errors => {
				this.$log.error('user login', 'auth.login ERROR', errors)()
				errors.json().then(error => {

					this.$appModal.show({
						error: true,
						title: this.$t(`errors.${error.code}.title`),
						message: this.$t(`errors.${error.code}.message`)
					})

				})
			}).finally(() => {
				this.loading = false
			})
		},
		parseJwt (token) {
			var base64Url = token.split('.')[1]
			var base64 = base64Url.replace('-', '+').replace('_', '/')
			return JSON.parse(window.atob(base64))
		},
	},
	beforeCreate () {
		this.$title(this.$t('base.auth.login'))
	},
	created () {
		const isAuthenticated = this.$store.getters.isAuthenticated
		if (isAuthenticated) {
			const userUid = this.$store.state.user.selectedAccount || this.$store.state.user.uid
			this.$router.push({ name: 'Dashboard', params: { user_uid: userUid } })
		}
	}
}
</script>

<style scoped>

.sk-login__link-extra:first-of-type {
	margin-top: 20px;

}

.sk-login__link-extra {
	margin: 5px 0;
	text-decoration: none;
	_color: var(--main-color);
	color: #000;
}

.sk-login__link-extra:visited {
	text-decoration: none;
	_color: var(--main-color);
	color: #000;
}

.auth > h1 {
	color: #000;
	border-bottom: 1px solid #000;
}

.form-group .btn {
    background-color: #000;
	border: none;
}

.form-group input{
    background-color: #000;
	border: none;
}


</style>



// WEBPACK FOOTER //
// src/components/auth/AuthLogin.vue